import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useCallback as n, useState as f } from "react";
import { useIsMounted as i } from './use-is-mounted.js';
function c() {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var _f = f(a),
    _f2 = _slicedToArray(_f, 2),
    l = _f2[0],
    r = _f2[1],
    t = i(),
    o = n(function (e) {
      t.current && r(function (u) {
        return u | e;
      });
    }, [l, t]),
    m = n(function (e) {
      return Boolean(l & e);
    }, [l]),
    s = n(function (e) {
      t.current && r(function (u) {
        return u & ~e;
      });
    }, [r, t]),
    g = n(function (e) {
      t.current && r(function (u) {
        return u ^ e;
      });
    }, [r]);
  return {
    flags: l,
    addFlag: o,
    hasFlag: m,
    removeFlag: s,
    toggleFlag: g
  };
}
export { c as useFlags };